import { useCallback } from "react"
import { useDevice } from "./device"
import { GestaoStorageKeys, useGestaoStorage } from "./gestao-storage"
import { useEmpresaAtual } from "../services/app/use-cases/empresa-atual"
import { useToastSaurus } from "../services/app"
import { getDevice, getFrontPdvUrl } from "../config/components/environment-variables"
import { EnumDeviceType } from "../model/enums/enum-device-type"
import { comprimirUrl, descomprimirUrl } from "../utils/comprimir-dados"

/**
 * Buffer nativo (MainActivity → SaurusFramework.consumirDadosAbrirAplicativo).
 * Cada chamada bem-sucedida com dados consome o buffer uma vez.
 */
export function consumirDadosPendentesBufferAbrirAppNativo(): Promise<string> {
    return new Promise((resolve) => {
        const w = window as unknown as {
            consumirDadosAbrirAplicativo?: (cb: (data: string, err: Error | null) => void) => void
        }
        if (typeof w.consumirDadosAbrirAplicativo !== "function") {
            resolve("")
            return
        }
        w.consumirDadosAbrirAplicativo((data, err) => {
            if (err) resolve("")
            else resolve(typeof data === "string" ? data : "")
        })
    })
}

export const useAbrirApp = () => {
    const { abrirAplicativo, openExternalUrl } = useDevice()
    const { showToast } = useToastSaurus()
    const { getRegistro } = useGestaoStorage()
    const { getEmpresaAtual } = useEmpresaAtual()

    const token = getRegistro(GestaoStorageKeys.Token, false)

    const abrirApp = useCallback(async (packageName: string, action?: string | undefined) => {
        const device = getDevice()
        const dados = {
            token: token ?? '',
            empresaId: getEmpresaAtual()?.id ?? '',
            action: action ?? ''
        }

        const urlString = JSON.stringify(dados)
        const urlComprimido = comprimirUrl(urlString)
        if (device === EnumDeviceType.CORDOVA) {
            try {
                await abrirAplicativo(packageName, urlComprimido)
                return
            } catch (err: any) {
                openExternalUrl(getFrontPdvUrl() + '/login?dados=' + urlComprimido);
            }
        }
        if (device === EnumDeviceType.CORDOVA_POS) {
            try {
                await abrirAplicativo(packageName, urlComprimido)
                return
            } catch (err: any) {
                showToast('error', err.message)
            }
        }
        window.location.href = (`${getFrontPdvUrl()}/login?dados=${urlComprimido}`)
    }, [abrirAplicativo, openExternalUrl, showToast, token, getEmpresaAtual])

    const getDadosFromUrl = useCallback((dados: string) => {
        try {
            const decoded = descomprimirUrl(dados)
            const parsed = JSON.parse(decoded)
            const { token, empresaId, action } = parsed
            const dadosDescomprimidos = {
                token,
                empresaId,
                action
            }
            return dadosDescomprimidos
        } catch (err: any) {
            showToast('error', err.message)
        }
    }, [showToast])

    return {
        abrirApp,
        getDadosFromUrl
    }
}